<template>
    <div class="patient-dob">
        <b-badge :variant="variant">
            <template v-if="showLabel">DOB</template>
            {{ dateString }}
        </b-badge>
    </div>
</template>

<script>
export default {
    name: "patient-dob",
    props: {
        participant: Object,
        showLabel: Boolean,
    },
    computed: {
        dateString() {
            return this.participant.validatedDob ? this.participant.validatedDob : 'No DOB'
        },
        variant() {
            return this.participant.validatedDob ? 'secondary' : 'danger'
        }

    }

}
</script>

<style scoped>

</style>
